import React from 'react';
import Tilt from 'react-parallax-tilt';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import '../../css/awards.css'



export const AwardCard = ({ award, index, onImageClick  }) => {
      const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <motion.div
      className="award-card"
      ref={ref}
      initial={{ opacity: 0, y: 50 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, delay: index * 0.2 }}
    >
      <Tilt glareEnable={true} glareMaxOpacity={0.3} scale={1.02} tiltMaxAngleX={10} tiltMaxAngleY={10}>
        <div className="card-inner">
          <img src={award.image} alt={award.title} className="award-img"  style={{ cursor: 'pointer' }}
            onClick={() => onImageClick(index)}/>
          <div className="award-info">
            <h3>{award.title}</h3>
            <span className="badge1">{award.badge}</span>
            {award.company&&( <p><strong> Company:</strong> &nbsp;&nbsp;&nbsp;&nbsp;{award.company}</p>)}
            {/* <p><strong>Category:</strong> {award.subtitle}</p> */}
          </div>
        </div>
      </Tilt>
    </motion.div>
  )
}
